module.exports = __webpack_public_path__ + "img/thy.d09c2817.png";